enum HouseHoldEnum {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  MORE_THAN_THREE = 4,
}

export default HouseHoldEnum;
